import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Ab wann hat Anna eine Verbesserung bemerkt?',
    answer: 'Bereits nach 7–10 Tagen zeigte Bruno deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
  }, {
    question: 'Ist das Topping auch für empfindliche Hunde geeignet?',
    answer: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
  }, {
    question: 'Wie viel gibt man täglich?',
    answer: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Anna hat mit der kleinsten Menge angefangen und langsam gesteigert.'
  }, {
    question: 'Was wenn es bei meinem Hund nicht wirkt?',
    answer: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
  }];
  return <section className="w-full px-4 py-16 bg-cream-dark/30" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-handwriting text-4xl md:text-5xl text-center text-forest font-bold mb-12" data-id="element-99">
          Häufige Fragen
        </motion.h2>

        <div className="space-y-4" data-id="element-100">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-brown/10 overflow-hidden" data-id="element-101">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-cream/50 transition-colors" data-id="element-102">
                <span className="font-serif font-bold text-gray-900 pr-4" data-id="element-103">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-forest shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-104" />
              </button>

              <AnimatePresence data-id="element-105">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-106">
                    <div className="px-6 pb-5 font-serif text-gray-700 leading-relaxed" data-id="element-107">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}